export enum UserRole {
  ITAdmin = 3,
  OfqualNewsAdmin = 17,
}

export const NewsRoles = [
  UserRole.ITAdmin,
  UserRole.OfqualNewsAdmin,
];